jQuery(function ($) {
  const $loadMoreBtn = $('.load-more-button');
  let currentPage = 1;
  const maxPages = parseInt($loadMoreBtn.data('max-pages'));

  $loadMoreBtn.on('click', function () {
    if (currentPage >= maxPages) return;

    $loadMoreBtn.prop('disabled', true).text(ajaxurl.loading);

    $.ajax({
      url: ajaxurl.url,
      type: 'POST',
      data: {
        action: 'load_more_posts',
        page: currentPage + 1,
        is_analytics_page: $('body').hasClass('page-template-template-analytics')
      },
      success: function (response) {
        if (response.success && response.data.html) {
          $('.entries').append(response.data.html);
          currentPage++;

          if (currentPage >= maxPages) {
            $loadMoreBtn.hide();
          } else {
            $loadMoreBtn.prop('disabled', false).text(ajaxurl.load_more);
          }
        }
      }
    });
  });
});
